import { useQuery, useMutation } from "@apollo/client";
import {
  ORGANIZATION_SETTINGS,
  ORGANIZATION_ROSTER_STATS,
  UPDATE_ORGANIZATION,
} from "../graphql";
import {
  UPDATE_ORGANIZATION_TIER,
  ENROLL_PENDING_ROSTER_USERS,
} from "../../organizations/graphql";
import type {
  Organization,
  UpdateOrganizationTierInput,
  UpdateOrganizationTierResult,
  EnrollPendingResult,
} from "../../organizations/types";

export function useOrganizationSettings(organizationId: string) {
  return useQuery<{ organization: Organization | null }>(
    ORGANIZATION_SETTINGS,
    {
      variables: { id: organizationId },
      skip: !organizationId,
      fetchPolicy: "cache-and-network",
    },
  );
}

export function useOrganizationRosterStats(organizationId: string) {
  return useQuery<{
    organizationRosterStats: { totalEntries: number };
  }>(ORGANIZATION_ROSTER_STATS, {
    variables: { organizationId },
    skip: !organizationId,
    fetchPolicy: "cache-and-network",
  });
}

export function useUpdateOrganizationSettings() {
  return useMutation(UPDATE_ORGANIZATION, {
    refetchQueries: ["OrganizationSettings", "MyManagedOrganizations"],
  });
}

export function useUpdateOrganizationTier() {
  return useMutation<
    { updateOrganizationTier: UpdateOrganizationTierResult },
    { organizationId: string; input: UpdateOrganizationTierInput }
  >(UPDATE_ORGANIZATION_TIER, {
    refetchQueries: ["OrganizationSettings", "MyManagedOrganizations"],
  });
}

export function useEnrollPendingRosterUsers() {
  return useMutation<
    { enrollPendingRosterUsers: EnrollPendingResult },
    { organizationId: string }
  >(ENROLL_PENDING_ROSTER_USERS, {
    refetchQueries: ["OrganizationSettings"],
  });
}
